import React from "react";
import { useState } from "react";

export default function Form(props){

   const [name , setName] = useState('');

  
   function handleChange(e){
       setName(e.target.value);
   }

   function handleSubmit(e){
    e.preventDefault();
    if(name.length>1){
      props.addTask(name);
    setName(""); 
    }else{
      alert("Please describe your task properly")
    }
   }

    return (
        <form onSubmit={handleSubmit}>
        <h2 className="label-wrapper">
          <label htmlFor="new-todo-input" className="label__lg">
          Whats needs to be done?
          </label>
        </h2>
        <input
          type="text"
          id="new-todo-input"
          className="input input__lg"
          name="text"
          autoComplete="off"
          value={name}
          onChange={handleChange}
        />
        <button type="submit" className="btn btn__primary btn__lg">
          Add
        </button>
      </form>
    )
}